import { ILocationSearchModel } from '@user/query/useLocationSearch'
import { ServiceLocation } from '@user/store/entityLocations'

export function locationSearchToShallowService(
  loc: ILocationSearchModel,
): ServiceLocation {
  const { address, billTo } = loc

  return {
    ...loc,
    address: {
      ...address,
      country: address.country ?? '',
      county: address.county ?? '',
    },
    altPhone: null,
    altPhoneExt: null,
    title: null,
    billTo: {
      address: {
        address: billTo.address.address ?? '',
        address2: billTo.address.address2 ?? '',
        city: billTo.address.city ?? '',
        state: billTo.address.state ?? '',
        postalCode: billTo.address.postalCode ?? '',
        country: billTo.address.country ?? '',
        county: billTo.address.county ?? '',
        latitude: billTo.address.latitude,
        longitude: billTo.address.longitude,
      },
      altPhone: billTo.altPhone ?? '',
      altPhoneExt: billTo.altPhoneExt ?? '',
      branch: billTo.branch,
      branchId: billTo.branchId?.toString() ?? '',
      company: billTo.company,
      email: billTo.email,
      firstName: billTo.firstName,
      id: billTo.id ?? '',
      lastName: billTo.lastName,
      mobile: billTo.mobile,
      number: billTo.number ?? '',
      phone: billTo.phone,
      phoneExt: billTo.phoneExt,
      billToTypeId: billTo.billToTypeId,
      divisionId: billTo.divisionId,
      title: null,
    },
    billToId: billTo.id,
    campaign: null,
    campaignId: null,
    contactName: null,
    division: null,
    divisionId: null,
    glCode: null,
    locationType: null,
    locationTypeDescription: null,
    locationTypeId: null,
    source: null,
    sourceId: null,
    taxCode: null,
    taxRate: null,
    terms: null,
  }
}
